module.exports = __webpack_public_path__ + "img/start_game_icon.d24eba8e.webp";